import { render, staticRenderFns } from "./snp.vue?vue&type=template&id=e7bc7c2c&scoped=true&"
import script from "./snp.vue?vue&type=script&lang=js&"
export * from "./snp.vue?vue&type=script&lang=js&"
import style0 from "./snp.vue?vue&type=style&index=0&id=e7bc7c2c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7bc7c2c",
  null
  
)

export default component.exports